import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Sap4MeHideHeaderService {
  private hideSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getHideStatus$(): Observable<boolean> {
    return this.hideSubject.asObservable();
  }

  hideHeader(): void {
    this.hideSubject.next(true);
  }

  revertHiding(): void {
    this.hideSubject.next(false);
  }
}
